import ChangeBeneficiaryModal from './ChangeBeneficiaryModal.container'

export default ChangeBeneficiaryModal
